<template>
    <div>
        <fpzLiability-common readonly></fpzLiability-common>
    </div>
</template>
<script>
import fpzLiabilityCommon from './fpzLiabilityCommon';
export default {
    name: 'fpzliabilityDetail',
    components: {
        fpzLiabilityCommon
    },
    data () {

    }
}
</script>